Vue.component('AmazonStarRating', require('./AmazonStarRating.vue').default);

Vue.component('Autocomplete', require('./Autocomplete.vue').default);

Vue.component('Datepicker', require('./Datepicker.vue').default);
Vue.component('DateRangePicker', require('./DateRangePicker.vue').default);

Vue.component('ToggleButtons', require('./ToggleButtons.vue').default);

Vue.component('InventoryInfo', require('./inventories/InventoryInfo.vue').default);
Vue.component('InventoryStatus', require('./inventories/InventoryStatus.vue').default);

Vue.component('AddToOrder', require('./orders/AddToOrder.vue').default);
Vue.component('EditOrderItem', require('./orders/EditOrderItem.vue').default);

Vue.component('Page', require('./layout/Page.vue').default);
Vue.component('Box', require('./layout/Box.vue').default);
Vue.component('Modal', require('./layout/Modal.vue').default);
Vue.component('FormGroup', require('./layout/FormGroup.vue').default);

Vue.component('Paginator', require('./paginator/Paginator.vue').default);
Vue.component('RoutePaginator', require('./paginator/RoutePaginator.vue').default);

Vue.component('SiteNotifications', require('./SiteNotifications.vue').default);

Vue.component('AddToWatchListButton', require('./watchLists/AddToWatchListButton.vue').default);

Vue.component('SortableColumnLink', require('./layout/SortableColumnLink.vue').default);

Vue.component('OrderItemRowActions', require('./orderitems/OrderItemRowActions.vue').default);

Vue.component('OrderItemsTable', require('./orderitems/OrderItemsTable.vue').default);

// Vendor Inventories
Vue.component('VendorInventoryWishlistItemsCell', require('./vendorinventories/VendorInventoryWishlistItemsCell.vue').default);
Vue.component('VendorInventoryPreviousOrdersCell', require('./vendorinventories/VendorInventoryPreviousOrdersCell.vue').default);
Vue.component('VendorInventoryProductBansCell', require('./vendorinventories/VendorInventoryProductBansCell.vue').default);
Vue.component('VendorInventoryOtherVendors', require('./vendorinventories/VendorInventoryOtherVendors.vue').default);
Vue.component('VendorInventoryDetailsCell', require('./vendorinventories/VendorInventoryDetailsCell.vue').default);
Vue.component('VendorInventorySalesRankCell', require('./vendorinventories/VendorInventorySalesRankCell.vue').default);
